import { useEffect, useState } from "react";
import CommonHeadingNBtns from "../../../components/common-components/CommonHeadingNBtns";
import FilterContainer from "../../../components/common-components/filters/filter-container";
import SearchFilter from "../../../components/common-components/filters/search-filter";
import PaymentLinkTable from "../../../components/payment-link-system/PaymentLinkTable";
import Loader from "../../../components/ui/Loader";
import { coins_spent_details } from "../../../data/ApiEndpoints";
import { useGetFetchNew } from "../../../data/Queries";
import DateRangerFilter from "../../../components/common-components/filters/date-ranger-filter";

const CoinDetails = ({ category_id, userInfoData, onClose }) => {
  const initialState = {
    start_date: "",
    end_date: "",
    search: "",
    category_id: category_id,
  };
  const [filters, setFilters] = useState(initialState);

  // console.log("filters===>", filters);

  const {
    data: coinsDetailsData,
    isLoading,
    refetch,
    isFetching,
  } = useGetFetchNew({
    token: userInfoData?.token,
    key: "coins_details",
    url: `${coins_spent_details}`,
    filters: {
      start_date: filters.start_date,
      end_date: filters.end_date,
      search: filters.search,
      category_id: category_id,
    },
  });

  useEffect(() => {
    refetch();
  }, [filters]);

  console.log("coinsDetailsData===>", coinsDetailsData);

  const tbColumns = [
    {
      dataField: "user_details",
      text: "User Details",
      formatter: (name, row) => {
        return (
          <span className="tb-data">
            {row?.user_name || "NA"}
            <br />
            <small className="lowercase underline gray">
              {row?.user_mobile || ""}
              <br />
              {row?.user_email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "gym_name",
      text: "Gym Name",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
        );
      },
    },
    {
      dataField: "category_name",
      text: "Category Name",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.category_name || "NA"}</span>;
      },
    },
    {
      dataField: "merchant_name",
      text: "Merchant Name",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.merchant_name || "NA"}</span>;
      },
    },
    {
      dataField: "coins_spent",
      text: "Coins Spent",
      formatter: (cell, row) => {
        return (
          <p
            className="tb-data"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <span className="redColorBg">{row?.coins_spent || "NA"}</span>
          </p>
        );
      },
    },
  ];

  return (
    <div className="createNewCTOModalContainer mod-width-100p">
      <CommonHeadingNBtns
        title="Coin Details"
        isLoading={false}
        btnTxt1={"Close"}
        onClick1={onClose}
      />

      <FilterContainer onReset={() => setFilters(initialState)}>
        <SearchFilter
          selectedSearch={filters.search}
          setSelectedSearch={(value) =>
            setFilters({ ...filters, search: value || "" })
          }
        />
        <DateRangerFilter
          startDate={filters.start_date || ""}
          endDate={filters.end_date || ""}
          onDateChange={(startDate, endDate) =>
            setFilters({ ...filters, start_date: startDate, end_date: endDate })
          }
        />
      </FilterContainer>

      {isLoading ? (
        <Loader />
      ) : (
        <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt30">
          <PaymentLinkTable
            tableData={coinsDetailsData?.data}
            tableColumns={tbColumns}
            userInfoData={userInfoData}
            loading={isLoading}
          />
        </div>
      )}
    </div>
  );
};

export default CoinDetails;
